import React, { useState } from 'react';
import { array } from 'prop-types';
import { Button } from 'reactstrap';
import SVG from 'react-inlinesvg';
import { FormattedMessage } from 'react-intl';
import { STATIC_PATH } from '../../config';
import FaqLastUpdateItem from './FaqLastUpdateItem';

const propTypes = {
  list: array.isRequired,
};

const defaultProps = {
  list: [],
};

const FaqLastUpdateBlock = ({ list }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="faq-last-update-block">
      <div className="faq-last-update-header">
        <p className="faq-last-update-title">
          <FormattedMessage id="faq.last_update" defaultMessage="Recent edits" />
        </p>
        <Button color="secondary" onClick={toggleCollapse}>
          <SVG
            src={`${STATIC_PATH}/img/action-icons/arrow.svg`}
            height="24"
            width="24"
            cacheRequests
            className={
              isCollapsed ? 'faq-last-update-arrow-collapsed' : 'faq-last-update-arrow-expanded'
            }
          />
        </Button>
      </div>

      <div className={isCollapsed ? 'faq-list-collapsed' : 'faq-list-expanded'}>
        <div className="faq-last-update-list">
          {list.map((item) => (
            <FaqLastUpdateItem key={item.id} article={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

FaqLastUpdateBlock.propTypes = propTypes;
FaqLastUpdateBlock.defaultProps = defaultProps;

export default FaqLastUpdateBlock;
